angular.module('gym.components').directive('trialReminderMessage', function() {
  return {
    restrict: 'E',
    template: require('templates/components/trialReminderMessage.html.slim'),
    scope: {
      plan: '='
    },
    controller: ["$scope", "$window", "FreeTrialRemindMessageText", function($scope, $window, FreeTrialRemindMessageText) {
      $scope.freeTrialReminderMessage = FreeTrialRemindMessageText.getMessage($scope.plan);
      return $scope.isPayor = window.currentUser.account_owner;
    }]
  };
});
